module.exports = __webpack_public_path__ + "assets/4a2d6b22a467169e4fa73da914795627.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/close.mp3
 ** module id = 369
 ** module chunks = 0
 **/